import { Box, Button, Input, Text } from '@chakra-ui/react'
import React from 'react';

const textStyles = {
  marginTop: '23px',
  fontSize: 'sm',
  marginBottom: '3px'
}

const inputStyles = {
  padding: '8px 15px',
  bgColor: '#F3F3F3',
  height: '46px',
  border: 'none',
  borderRadius: '5px',
  w: '100%',
  color: 'black',
  fontSize: '14px',
}

const ChangePasswordTextfields = () => {
  return (
    <Box>
      <Text {...textStyles} marginTop='0px'>Old Password:</Text>
      <Input {...inputStyles} />
      <Text {...textStyles}>New Password:</Text>
      <Input {...inputStyles} />
      <Text {...textStyles}>Confirm New Password:</Text>
      <Input {...inputStyles} />
      <Button
        marginTop='40px'
        w='100%'
        fontWeight='400'
        backgroundColor='#0d6efd'
        color='white'
        _hover={{
          backgroundColor: '#0a58ca'
        }}
      >
        Submit
      </Button>
    </Box>
  )
}

export default ChangePasswordTextfields